import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(VApp,[_c('Toolbar'),_c(VContent,[_c('Content')],1),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }